import { useMemo } from 'react';
import { Box, useThemeValue } from '@altermaind/web/ui';
import { useResponsiveStyle } from '@/_shared/hooks/useResponsiveStyle';
import { convertColorToRgba } from '../../helpers/convertColorToRgba';

export const BackgroundBox = () => {
  const primary = useThemeValue('colors', 'primary');
  const { genericResponsiveValue } = useResponsiveStyle();

  const background = useMemo(() => {
    if (primary && !primary.includes('rgba')) {
      return convertColorToRgba(primary as string);
    }
    return primary;
  }, [primary]);

  return (
    <Box
      background={`conic-gradient(from 260deg at 75% 40%, ${background?.replace('1)', '.2)')} 0deg, ${background?.replace('1)', '.7)')} 300deg)`}
      height={genericResponsiveValue({
        breakPoints: { desktop: '200px' },
        defaultValue: '120px',
      })}
      borderRadius='m'
      mb={genericResponsiveValue({
        breakPoints: { desktop: 'l' },
        defaultValue: 'xs',
      })}
      display='flex'
      alignItems='center'
      justifyContent='center'
    />
  );
};
